import { useEffect, useState } from 'react';
import type { AnnouncementRecord, AdminSettings } from './lib/admin';

export function HomeAnnouncements({ initData }: { initData: string }) {
  const [items, setItems] = useState<AnnouncementRecord[]>([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let cancelled = false;
    void fetch('/api/v1/app/home', { cache: 'no-store', headers: { Accept: 'application/json', Authorization: `tma ${initData}` } })
      .then(async (response) => {
        if (!response.ok) return null;
        return response.json() as Promise<{ announcements: AnnouncementRecord[]; settings: AdminSettings }>;
      })
      .then((body) => { if (!cancelled && body) setItems(body.announcements); })
      .catch(() => undefined);
    return () => { cancelled = true; };
  }, [initData]);

  useEffect(() => {
    if (items.length <= 1) return;
    const timer = window.setInterval(() => setIndex((value) => (value + 1) % items.length), 6000);
    return () => window.clearInterval(timer);
  }, [items.length]);

  if (!items.length) return null;
  const item = items[index % items.length]!;
  const content = <>{item.imageUrl ? <img src={item.imageUrl} alt="" /> : null}<div><strong>{item.title}</strong><p>{item.body}</p>{items.length > 1 ? <small>{index + 1} / {items.length}</small> : null}</div></>;
  if (item.ctaUrl) return <a className="home-announcement" href={item.ctaUrl} target="_blank" rel="noreferrer">{content}</a>;
  return <div className="home-announcement">{content}</div>;
}
